import React from 'react';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { HomeWrapper } from '../../src/components/HomePage/HomeBanner/styled';
import GlobalStyle from '../../src/styles/globalStylesV2';
import Refund from '../../src/components/PrivacyPolicy/Refund';
import NewFooter from '../../src/components/HomePage/NewFooter';
import { getSeoVisibility } from '../../src/appconfig';
import { FAQPageJsonLd, NextSeo } from 'next-seo';
import { returnRefundFaqData } from '../../src/components/PrivacyPolicy/Refund/constants';
import { useRouter } from 'next/router';

export default function RefundCancellationComponent() {
  const router = useRouter();
  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={'Returns, Refunds & Cancellation - Mylo | mylofamily.com'}
            description={
              'Mylo allows easy replacement, exchange, return & refund of eligible products. Return window is 15 days so once the order is delivered, you can return within 15 days of receiving the orders. Mylo promises to deliver the best experience to its customers, you can check our return, refund and cancellation policy here.'
            }
            openGraph={{
              title: 'Returns, Refunds & Cancellation - Mylo | mylofamily.com',
              description:
                'Mylo allows easy replacement, exchange, return & refund of eligible products. Return window is 15 days so once the order is delivered, you can return within 15 days of receiving the orders. Mylo promises to deliver the best experience to its customers, you can check our return, refund and cancellation policy here.',
              type: 'website',
              url: `https://mylofamily.com${router.asPath}`,
              images: [
                {
                  url: 'https://mylofamily.com/v2/static/images/512mylo.png',
                  width: 512,
                  height: 512,
                },
              ],
            }}
          />
          <FAQPageJsonLd
            mainEntity={returnRefundFaqData?.map((element) => {
              return {
                questionName: element?.question,
                acceptedAnswerText: element?.answer,
              };
            })}
          />
        </>
      ) : null}
      <GlobalStyle />
      <NewHeader nostrip={true} />
      <HomeWrapper noPadding>
        <Refund />
      </HomeWrapper>
      <NewFooter />
    </>
  );
}
